import React from 'react'
import TextField from '../../../core/common/textFields/TextField'

const SecurityTab = () => {
    return (
        <>
            <h5>Security Settings</h5>
            <p className='mb-2'>Last Changed Jul 16,2024</p>
            <div className='row'>
                <div className="col-md-12">
                    <div className="form-wrap">
                        <TextField
                            label="Current Password"
                            type="text"
                        // {...formik.getFieldProps("companyName")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="New Password"
                            type="text"
                        // {...formik.getFieldProps("companyName")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="form-wrap">
                        <TextField
                            label="Confirm Password"
                            type="text"
                        // {...formik.getFieldProps("companyName")}
                        // disabled={viewOnly}
                        />
                    </div>
                </div>
            </div>
            <div className="submit-button d-flex justify-content-end mt-3">
                        <button className="btn btn-light-red ">
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary">
                            Change Password
                        </button>
                    </div>
        </>
    )
}

export default SecurityTab